import { getMessageContentAsText, isMessageLike } from '@/utils/messages';

import { Message, messageType } from '../../../data/message';
import { TraceLog } from '../../../data/misc';
import { truncateString } from '../../../utils';

export const getContentTextPreview = (traceLog: TraceLog) => {
  if (traceLog.entry.type === 'checkpoint') return 'Checkpoint';
  if (traceLog.entry.type === 'error') return 'Error';
  if (traceLog.entry.type === 'pending') {
    return traceLog.entry.name;
  }

  const msgs =
    traceLog.entry.data.type === 'Message'
      ? [traceLog.entry.data.value]
      : traceLog.entry.data.type === 'Messages'
      ? traceLog.entry.data.value
      : [];

  if (traceLog.entry.data.type === 'Documents') {
    return `${traceLog.entry.data.value.length} documents`;
  }

  if (traceLog.entry.data.type === 'Document') {
    return 'Document';
  }

  const [first] = msgs;

  if (first === undefined) {
    return traceLog.entry.name;
  }

  return getMessagePreview(first);
};

export const getMessagePreview = (msg: Message) => {
  const msgType = messageType(msg);

  if (msgType === 'tool') {
    return msg.name ?? 'Tool';
  }

  if ((msg.tool_calls?.length ?? 0) > 0) {
    return msg.tool_calls?.map((x) => x.name).join(', ') ?? 'tool call';
  }

  return truncateString(
    (isMessageLike(msg) ? getMessageContentAsText(msg) : null) ?? ''
  );
};

export const getMessageTitle = (msg: Message) => {
  let title = 'Message';
  const type = messageType(msg);
  if (type === 'remove') title = 'Deleted Message';
  else title = type.charAt(0).toUpperCase() + type.slice(1) || title;
  if (title === 'Ai') title = 'AI';

  return title;
};
